import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import LoadingPanel from './../../../components/LoadingPanel';
import { shippingOrders, workOrders } from './../../../../modules/customer/profile';
import { utcToDisplayDate } from './../../../../common/formatting';

const OrdersBox = ({ shippingOrderClickHandler, workOrderClickHandler, customerId, shippingOrder, workOrder, isLoadingShippingOrder, isLoadingWorkOrder }) => {
    return (
        <div className="container-fluid">
            {isLoadingShippingOrder || isLoadingWorkOrder &&
                <LoadingPanel />
            }
            {!isLoadingShippingOrder && !isLoadingWorkOrder &&
                <div className="row">
                    <div className="col-xs-6 label-block">
                        SHIPPING ORDERS:
                    </div>
                    <div className="col-xs-6 details-block">
                        <div className="order-number">{shippingOrder !== undefined ? shippingOrder.id : "-"}</div>
                        <div className="order-status">{shippingOrder !== undefined ? "(" + shippingOrder.currentStatus + ")" : "-"}</div>
                    </div>

                    <div className="col-xs-6 label-block">
                        WORK ORDERS:
                    </div>
                    <div className="col-xs-6 details-block">
                        <div className="order-number">{workOrder !== undefined ? workOrder.id : "-"}</div>
                        <div className="order-status">{workOrder !== undefined ? "(" + workOrder.currentStatus + ")" : "-"}</div>
                    </div>
                </div>
            }
        </div>

    );
};

const mapStateToProps = createStructuredSelector({
    shippingOrder: shippingOrders.selectors.getNewestShippingOrder,
    workOrder: workOrders.selectors.getNewestWorkOrder,
    isLoadingShippingOrder: shippingOrders.selectors.isLoading,
    isLoadingWorkOrder: workOrders.selectors.isLoading
});

const mapDispatchToProps = (dispatch, props) => ({
    workOrderClickHandler: (customerId) => dispatch(push(`/customer/${customerId}/workorders`)),
    shippingOrderClickHandler: (customerId) => dispatch(push(`/customer/${customerId}/shippingorders`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrdersBox);
